import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import { XYChart } from "../../../../../../components/molecules/Charts";
import { IAlertsTimeline } from "../../../../../../types";
import { useActionsHook, useTypedSelectorHook } from "../../../../../../utils";
import { CustomStack } from "./_styled.constants";

/**
 * Вкладка таймлайна за период дня Alerts Timeline - All *
 */

export const TimelineAll: React.FC = () => {
  const { alertsTimeline } = useTypedSelectorHook(({ alerts }) => alerts);
  const { getAlertsTimelineActions } = useActionsHook();
  const [timelineAll, setTimelineAll] = useState<IAlertsTimeline[]>([]);

  useEffect(() => {
    getAlertsTimelineActions("all");
  }, []);

  useEffect(() => {
    if (alertsTimeline) {
      setTimelineAll(
        alertsTimeline.map((item) => {
          return {
            ...item,
          };
        })
      );
    }
  }, [alertsTimeline]);

  return (
    <CustomStack>
      <Typography component="span" color="primary.main">
        By quantity
      </Typography>
      <Typography component="label" color="primary.main">
        Year
      </Typography>
      <XYChart
        id="timelineAll"
        category="time"
        value="sum"
        data={timelineAll}
      />
    </CustomStack>
  );
};
